module.exports = __webpack_public_path__ + "img/8.272f963c.png";